import { call, put, takeEvery, select, takeLatest } from "redux-saga/effects";
import { types } from "../action-types";
import {
    fetchUserProfileFailure,
    fetchUserProfileSuccess,
} from "../actions";
import {
    fetchProfileURL,
    putRatingAPI
} from "../../API/API";

function* putRatingSaga(request) {
    try {

        const response = yield call(() => putRatingAPI(request.payload)); // API Backend
        yield put({ type: types.PUT_RATING_SUCCESS, payload: response.data });
    }
    catch (error) {
        yield put({ type: types.PUT_RATING_FAILURE, error });
    }
};

export function* watchPutRatingSaga() {
    yield takeLatest(types.PUT_RATING_REQUESTED, putRatingSaga);
};